export const HEAD_CELLS = [
  {
    id: 'legalName',
    label: 'Legal Name',
  },
  {
    id: 'email',
    label: 'Email',
  },
  {
    id: 'counselorAssign',
    label: 'Assign as counselor',
  },
  {
    id: 'teacherAssign',
    label: 'Assign as teacher',
  },
];

export const CHECKBOX_TOOLTIP_TEXT =
  'Looks like there already are students waiting for your recommendations and reports for applications process.';
